<kendo-expansionpanel [title]="'Tags'"
                      [subtitle]=""
                      [expanded]="true">
    <div class="row" *ngIf="tagMapList.length>0">
        <div class="col">
            <kendo-grid #tagMapGrid
                        [data]="tagMapListView"
                        [height]="400"
                        [pageable]="false"
                        [resizable]="true"
                        [filterable]="false"
                        (dataStateChange)="tagMapListStateChange($event)">
                <kendo-grid-column title="">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div *ngIf="readonly!=true">
                            <!--
                            <button type="button" class="btn btn-sml"
                               [ngClass]="dataItem.recordID>0 ? 'btn-' + dataItem.colorClassName : 'btn-light'"
                               (click)="setTag(dataItem)">{{dataItem.tagTypeName}}</button>-->
                            <input type="checkbox" style="margin:5px;transform: scale(1.5);"
                                   id="tagMapID{{ dataItem.tagMapID }}"
                                   name="tagMapID{{ dataItem.tagMapID }}"
                                   (change)="setTag(dataItem)"
                                   [checked]="dataItem.recordID>0"
                                   autocomplete="off" />
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="tagTypeName" title="Tag">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button type="button" class="btn btn-sm btn-{{dataItem.colorClassName}}">{{dataItem.tagTypeName}}</button>
                        <!--<span class="text-{{dataItem.colorClassName}}">{{dataItem.tagTypeName}}</span>-->
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="tagTypeDescription" title="Description">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="text-{{dataItem.colorClassName}}">{{dataItem.tagTypeDescription}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="tagNote" title="Note">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="text" [(ngModel)]="dataItem.tagNote" style="min-width:150px" class="form-control k-input" (change)="setTagNote(dataItem)" [disabled]="dataItem.tagMapID==0||readonly==true" />
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</kendo-expansionpanel>
